import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * RouteAnnouncer — visually-hidden aria-live region that announces the
 * new page title whenever the route changes.  Required because the
 * SPA does not perform a full reload, so screen readers never hear
 * "Speakers page loaded" without it.
 *
 * The <Seo> component sets document.title shortly after the route
 * change, so we wait one tick before reading it.
 */
export function RouteAnnouncer() {
  const { pathname } = useLocation();
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Wait for <Seo> in the new route to update document.title
    const t = window.setTimeout(() => {
      const title = document.title || 'Page loaded';
      setMessage(`Navigated to ${title}`);
    }, 80);
    return () => window.clearTimeout(t);
  }, [pathname]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {message}
    </div>
  );
}
